import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowUpRight } from 'lucide-react';
export function ColombiaEnMapas() {
  return <section id="hito-4" className="py-24 md:py-32 px-4 md:px-8 scroll-mt-24" data-id="element-133" data-mp="2ki7zezm5eszg">
      <div className="max-w-[1400px] mx-auto" data-id="element-134" data-mp="2pg9hbh7u8m9c">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-135" data-mp="2tio0k2ff5o15">
          <div className="lg:col-span-5" data-id="element-136" data-mp="2tgjouyba3kqb">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-137" data-mp="2yi93sp1mgijo">
              Avance 04 · Apropiación de los productos del IGAC
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-forest leading-[1.05]" data-id="element-138" data-mp="387sm9tlfaae0">
              Colombia en Mapas
            </h2>
            <p className="mt-5 text-lg text-charcoal/70 font-light" data-id="element-139" data-mp="3d63w44bpwkw8">
              Información geoespacial para la gestión sostenible del territorio.
            </p>
          </div>
          <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-140" data-mp="3m8d6mu6zke9m">
            <p className="text-lg md:text-xl text-charcoal/85" data-id="element-141" data-mp="qtahxmdssqay">
              Contar con información geográfica confiable, actualizada y
              accesible es fundamental para la planificación y gestión
              sostenible de los territorios. Por esta razón, el Proyecto TEFOS
              ha apoyado el fortalecimiento de{' '}
              <strong className="font-medium text-charcoal" data-id="element-142" data-mp="cusvrt3jjlv5">
                Colombia en Mapas
              </strong>
              , el Portal Nacional de Información Geoespacial, una plataforma
              que integra y pone a disposición información oficial generada por
              diferentes entidades del Estado.
            </p>
            <p data-id="element-143" data-mp="vrtzzbp9thy1">
              A través de esta herramienta es posible acceder a datos
              geoespaciales de diferentes temáticas, facilitando el análisis del
              territorio y apoyando procesos de gobernanza, ordenamiento
              territorial, gestión ambiental y toma de decisiones.
            </p>
            <p data-id="element-144" data-mp="3ip4u16i6sgqa">
              En este video conocerá algunas de las funcionalidades de la
              plataforma y cómo consultar información geográfica de manera
              sencilla para contribuir a la gestión sostenible de los
              territorios forestales y otras áreas estratégicas del país.
            </p>
          </div>
        </div>

        {/* Video */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7
      }} data-id="element-145" data-mp="2yzkz8zyxp919">
          <div className="inline-flex items-center gap-2 bg-forest text-bone px-4 py-2 text-xs font-bold uppercase tracking-wider mb-4" data-id="element-146" data-mp="2uyiy2dlgimwn">
            <MapPin size={14} data-id="element-147" data-mp="t6mb87tu9qmk" />
            Portal Nacional de Información Geoespacial
          </div>
          <div className="relative w-full bg-charcoal overflow-hidden" style={{
          aspectRatio: '16/9'
        }} data-id="element-148" data-mp="13akwsa47v3l3">
            <iframe loading="lazy" title="Colombia en Mapas — Gumlet video player" src="https://play.gumlet.io/embed/6a351ac55c94624b773ed762" style={{
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%'
          }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-149" data-mp="y9n4h4phst5v" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8" data-id="element-150" data-mp="nzjdfyhlx9n">
          <a href="https://www.colombiaenmapas.gov.co/" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 bg-forest hover:bg-forest-light text-bone px-8 py-4 text-base font-medium tracking-wide transition-colors" data-id="element-151" data-mp="3u8nzavy6k38k">
            Acceder a Colombia en Mapas
            <ArrowUpRight size={18} className="transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-152" data-mp="3bj8xv0el1c3n" />
          </a>
        </motion.div>
      </div>
    </section>;
}